module.exports = __webpack_public_path__ + "img/hzwx.1acac617.png";